import { normalize } from 'normalizr';

// Schemas
import schemas from '../../schemas';

export const normalizr = store => next => action => {
    const schemaName = action.meta && action.meta.schemaName;

    if (!schemaName || !action.payload || action.error) {
        return next(action);
    }
    const schema = schemas[schemaName];

    if (!schema) {
        return next(action);
    }
    const normalized = normalize(action.payload, schema);
    const newAction = Object.assign({}, action, {
        payload: normalized
    });
    return next(newAction);
};
